import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "label", "caption", "withMobileOffset", "captionSize", "children", "invert", "disabled", "error", "width", "onCaptionClick", "captionDisabled"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../Text";
import styles from "./styles.pcss";
var cnControlWrapper = cnBem('control-wrapper', styles);
var getColor = function getColor(type, disabled, invert, isError) {
  if (isError && !disabled) {
    return "var(--control-wrapper-".concat(type, "-color-error)");
  }
  return "var(--control-wrapper-".concat(type, "-color-").concat(invert ? 'invert' : 'default').concat(disabled ? '-disabled' : '', ")");
};
export var ControlWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    label = props.label,
    caption = props.caption,
    _props$withMobileOffs = props.withMobileOffset,
    withMobileOffset = _props$withMobileOffs === void 0 ? true : _props$withMobileOffs,
    _props$captionSize = props.captionSize,
    captionSize = _props$captionSize === void 0 ? 'small' : _props$captionSize,
    children = props.children,
    invert = props.invert,
    disabled = props.disabled,
    error = props.error,
    _props$width = props.width,
    width = _props$width === void 0 ? 'full' : _props$width,
    onCaptionClick = props.onCaptionClick,
    captionDisabled = props.captionDisabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnControlWrapper({
      width: width,
      withMobileOffset: withMobileOffset
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "components-ControlWrapper"
  }), (label || error) && /*#__PURE__*/React.createElement(Text, {
    className: cnControlWrapper('label'),
    style: _defineProperty({}, '--control-wrapper-label-color', getColor('label', disabled, invert, !!error)),
    tagName: "label",
    variant: "caption-accent-medium"
  }, error || label), children, caption && /*#__PURE__*/React.createElement(Text, _extends({
    className: cnControlWrapper('caption', {
      size: captionSize
    }),
    style: _defineProperty({}, '--control-wrapper-caption-color', getColor(captionSize === 'big' ? 'button' : 'caption', disabled, invert)),
    tagName: onCaptionClick ? 'button' : 'p',
    variant: captionSize === 'big' ? 'body-accent-small' : 'caption-accent-medium'
  }, onCaptionClick ? {
    type: 'button',
    disabled: captionDisabled || disabled,
    onClick: onCaptionClick
  } : {}), caption));
});